// extracted by mini-css-extract-plugin
module.exports = {"eventBody":"Event_eventBody__cdVer"};